import { merge } from 'lodash'
import { DateTime } from 'luxon'
import { BillingCode } from 'src/participantHistory/intakeNote/billingCodeConstants'
import { CheckinCallNoteType } from './CheckinCallNoteSchema'

const DUMMY_TEXT = 'The quick brown fox jumps over a lazy dog'

// Takes the defaults too because a draft of an exception status lacks the call-had groups.
export const getDummyCheckinCallNote = (
  values: CheckinCallNoteType,
  defaultValues: CheckinCallNoteType
): CheckinCallNoteType => {
  const callStart = values.CALL_START_TIME
    ? DateTime.fromISO(values.CALL_START_TIME)
    : DateTime.now().startOf('day').set({ hour: 10 })

  return merge({}, defaultValues, values, {
    date: values.date || callStart.toFormat('yyyy-MM-dd'),
    FIRST_NAME: values.FIRST_NAME || 'Dummy',
    LAST_NAME: values.LAST_NAME || 'Patient',
    MEMBER_ID: values.MEMBER_ID || '12345678',
    PROVIDER_NAME: values.PROVIDER_NAME || 'Dummy Provider',
    LICENSE_TYPE: values.LICENSE_TYPE || 'LCSW',
    CALL_START_TIME: values.CALL_START_TIME || (callStart.toUTC().toISO() ?? ''),
    CALL_END_TIME: values.CALL_END_TIME || (callStart.plus({ minutes: 30 }).toUTC().toISO() ?? ''),
    CALL_STATUS: 'CALL_HAD',
    SMART_GOALS: DUMMY_TEXT,
    BILLING_CODES: values.BILLING_CODES?.length ? values.BILLING_CODES : [BillingCode.F10_10],
    REASON_FOR_CALL: 'PROGRAM_ENGAGEMENT',
    INTERVENTIONS: {
      COGNITIVE_RESTRUCTURING: true,
    },
    RISK_LEVEL_HAS_CHANGE: 'no',
    PROTECTIVE_FACTORS_IDENTIFIED: {
      STRONG_SOCIAL_SUPPORT: true,
    },
    NEXT_STEPS: {
      NO_FURTHER_ASSISTANCE_NEEDED: true,
    },
    PARTICIPANT_RESPONSE: {
      ENGAGED_AND_SHOWED_UNDERSTANDING_OF_TECHNIQUES: true,
    },
    PLAN: {
      CONTINUE_SUPPORT_VIA_APP_CHAT: true,
    },
  } as const)
}
